const API_KEY = process.env.REACT_APP_API_KEY;
const API_URL = process.env.REACT_APP_API_URL;

let cachedToken = null;
let tokenExpiry = 0;

export async function getBearerToken() {
    const now = Date.now();
    if (cachedToken && tokenExpiry > now) {
        return cachedToken;
    }
    const res = await fetch(`${API_URL}/token`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Api-Key': API_KEY
        }
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || 'Failed to get token');
    }
    const data = await res.json();
    cachedToken = data.access_token;
    tokenExpiry = now + (3600 - 300) * 1000;
    return cachedToken;
}

export async function downloadResume(turnstileToken, bearerToken, deviceId) {
    const res = await fetch(`${API_URL}/resume`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${bearerToken}`,
            'X-Device-ID': deviceId
        },
        body: JSON.stringify({
            token: turnstileToken,
            action: 'resume_download',
            user_agent: navigator.userAgent,
            user_ip: '',
            ja3: ''
        })
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || 'Failed to fetch resume');
    }
    return await res.blob();
}